import Icon from '../components/Icon.vue'

Icon.register({
  lemon: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M489 23c23.1 23.1 28.9 54.4 16.8 75.1-34.3 58.9 53.1 181.2-86.7 321.1s-262.2 52.4-321.1 86.7c-20.7 12.1-52 6.3-75.1-16.8-23.1-23.1-28.9-54.4-16.8-75.1 34.3-58.9-53.1-181.2 86.7-321.1s262.2-52.4 321.1-86.7c20.7-12.1 52-6.3 75.1 16.8zM243.9 95.5c8.6-2.1 13.8-10.8 11.6-19.4-2.1-8.6-10.8-13.8-19.4-11.6-69.8 17.5-154.2 101.9-171.6 171.6-2.1 8.6 3.1 17.3 11.6 19.4 1.3 0.3 2.6 0.5 3.9 0.5 7.2 0 13.7-4.9 15.5-12.1 14.5-58.2 90.2-133.8 148.4-148.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lemon.js
// module id = 1514
// module chunks = 0